import { render } from "./file-favourites.vue?vue&type=template&id=6e29bfff"
import script from "./file-favourites.vue?vue&type=script&lang=js"
export * from "./file-favourites.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__